import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';

// Lazy load all pages for better performance
const Home = lazy(() => import('./pages/Home'));
const Questions = lazy(() => import('./pages/Questions'));
const Profile = lazy(() => import('./pages/Profile'));
const Battle = lazy(() => import('./pages/Battle'));
const Inbox = lazy(() => import('./pages/Inbox'));

export const App: React.FC = () => {
  return (
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/inbox" element={<ProtectedRoute><Inbox /></ProtectedRoute>} />
            <Route path="/questions" element={<Questions />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/battle" element={<Battle />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
  );
};

export default App;